export enum ActionType {
  GET_SHIPMENT_PACKAGE_REQUEST = `shipments/packages/GET_SHIPMENT_PACKAGE_REQUEST`,
  GET_SHIPMENT_PACKAGE_REQUEST_SUCCESS = `shipments/packages/GET_SHIPMENT_PACKAGE_REQUEST_SUCCESS`,
  GET_SHIPMENT_PACKAGE_REQUEST_FAILURE = `shipments/packages/GET_SHIPMENT_PACKAGE_REQUEST_FAILURE`,

  CLEAR_MESSAGE_ERROR = `shipments/packages/CLEAR_MESSAGE_ERROR`,
  CLEAR_STATE = `shipments/packages/CLEAR_STATE`,
}

export type Action = any;
//   | FSA<ActionType.TOKEN_REQUEST>
